// extracted by mini-css-extract-plugin
export var bar = "infoBar-module--bar--yiiii";
export var socials = "infoBar-module--socials--tIjbn";
export var social = "infoBar-module--social--UjrCC";
export var language = "infoBar-module--language--gq8eW";
export var lang = "infoBar-module--lang--7LSbq";
export var fadein = "infoBar-module--fadein--vqwNh";